import React, { useContext, useEffect, useState } from 'react';
import { ElementConfigType, PageEditorStoreContext } from '../../store/PageEditorStore';
import style from './MultiSuperTab.module.scss';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';

type Props = ElementConfigType;

export const MultiSuperTabComponent: MyComponentType<Props> = (props: Props) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  const { elements, styles, parentNodeIsBody } = props;
  const [multiTapOneDate, setMultiTapOneDate] = useState<ElementConfigType[]>([]);
  const [multiTapContentTwoDate, setMultiTapContentTwoDate] = useState<ElementConfigType[]>([]);
  const [clickIndex, setClickIndex] = useState(0); // 记住上次点了啥

  useEffect(() => {
    setMultiTapOneDate(elements.filter((d) => d.index % 2 === 1));
    setMultiTapContentTwoDate(elements.filter((d) => d.index % 2 === 0));
    // elements长度变化 变化 重新选择第一个
    if (elements.length / 2 < clickIndex + 1) {
      setClickIndex(0);
    }
  }, [elements]);

  const handleTabClick = (i) => {
    setClickIndex(i);
  };

  return (
    <div
      className={style.multi}
      style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {}, styles)}
    >
      <div>
        {(multiTapContentTwoDate.length === 0 ? elements.filter((d) => d.index % 2 === 0) : multiTapContentTwoDate).map(
          (d, index) => {
            return (
              <div key={d.index} className={`${index === clickIndex ? 'flex' : 'hidden'}`}>
                <props.ComponentBasicRender tip="Tab切换 或者 卖点组件" {...toJS(d)} styles={{ width: '100%' }} />
              </div>
            );
          },
        )}
      </div>
      <div className="z-10 flex flex-nowrap md:flex-wrap overflow-x-auto">
        {(multiTapOneDate.length === 0 ? elements.filter((d) => d.index % 2 === 1) : multiTapOneDate).map(
          (d, index) => {
            const toJSD = toJS(d);
            // 这里处理是为了让移动端文字不换行
            if (toJSD.elements[0]) {
              toJSD.elements[0].styles = { ...(toJSD?.elements[0]?.styles || {}), whiteSpace: 'nowrap' };
            }
            return (
              <div
                style={!pageEditorStore.isRenderHtml ? { border: '1px solid #F7C001' } : {}}
                key={d.nodeId}
                className={`multi-tap-title ${clickIndex === index ? 'gold' : ''} flex justify-center`}
                onClick={() => {
                  handleTabClick(index);
                }}
              >
                <button className={'block mr-6 mt-5 pb-1'}>
                  <props.ComponentBasicRender {...toJSD} height="h-10" />
                </button>
              </div>
            );
          },
        )}
      </div>
    </div>
  );
};

MultiSuperTabComponent.definition = {
  id: ComponentIdEnum.MULTI_SUPER_TAB_COMPONENT,
  name: 'Tab切换组件自由版',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/1F9FgNhXRqND8g7b6Dprb',
  position: 5, // 显示顺序
  config: {},
  privateSchema: {
    // subContainersNumber: 4,
    subContainersNode: [
      {
        componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT, // 点击的 文本容器
        privateSchema: {
          text: 'Basic-2 Stage Inverted',
          opacity: 0.5,
        },
      },
      {
        componentId: ComponentIdEnum.BASIC_COMPONENT, //
      },
      {
        componentId: ComponentIdEnum.TEXT_CONTENT_COMPONENT, // 点击的 文本容器
        privateSchema: {
          text: 'Aurora-3 Stage',
          opacity: 0.5,
        },
      },
      {
        componentId: ComponentIdEnum.BASIC_COMPONENT, //
      },
    ],
    subContainersNodeNumber: 4,
  }, // 组件自己的属性 不能通用的部分
  styles: {},
};
